module.exports = __webpack_public_path__ + "img/tree-07-e-trunk.dc39de0e.png";